var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "router-link",
          {
            attrs: {
              tag: "a",
              to: { name: "admins.profile.show", params: { id: _vm.admin.id } },
            },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "flex flex-row align-center justify-start col-xs-12 col-md-10",
              },
              [
                _c("div", { staticClass: "details" }, [
                  _c("h3", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(_vm.admin.name)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("span", { staticClass: "label label-info py-10" }, [
                    _vm._v(_vm._s(_vm.admin.role)),
                  ]),
                ]),
                _vm._v(" "),
                _vm.$vlastMode && _vm.admin.activation_notified_at
                  ? _c("div", [
                      _vm._v(
                        "(Activation Email Sent: " +
                          _vm._s(
                            _vm._f("dateTimezone")(
                              _vm.admin.activation_notified_at,
                              _vm.$user.timezone,
                              _vm.$user.date_format_preference,
                              true,
                              true
                            )
                          ) +
                          ")"
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            !_vm.admin.deleted_at && _vm.$userIsRestrictedAdmin
              ? _c(
                  "button",
                  { staticClass: "btn btn-lg btn-success btn-job-complete" },
                  [[_vm._v("View")]],
                  2
                )
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-12 col-md-2" },
          [
            !_vm.admin.deleted_at &&
            _vm.$userIsAdmin &&
            !_vm.$userIsRestrictedAdmin
              ? _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-lg btn-danger btn-job-complete",
                    attrs: { click: _vm.handleDeleteAdminCallback },
                  },
                  [
                    [
                      _c("i", { staticClass: "fa fa-trash" }),
                      _vm._v(" Delete User"),
                    ],
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.admin.deleted_at
              ? _c(
                  "div",
                  {
                    staticClass:
                      "btn btn-danger-outline btn-block btn-not-clickable truncate",
                  },
                  [_vm._v("\n        Deleted\n      ")]
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }